/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';
import firebase from 'firebase/compat/app';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
//using the working assumption that there is not reason for anyone other then the user
//to access their own preferences...
angular.module('ticketspaceApp').factory('firebaseUserPreferences', [
	'$q',
	'$firebaseObject',
	function ($q, $firebaseObject) {
		let userId;

		let defaults = {
			planSortType: 'id',
			showSharedSamplePlan: true,
			showAllRolesOnPlans: false,
			showMyRoleOnPlans: false,
			showLaborCount: true,
			canvasTextScale: 1,
			forceCanvasRenderer: false,
			canvasTextOptions: 'default',
			reportsLastProjectId: null,
			reportsLastAsOfDate: null,
			reportsLastUpToDate: null,
			reportsLastNumberOfWeeks: '1',
			reportsLastGanttTimeScale: 'day',
			reportsLastTimeScale: 20,
			reportsLastShowCompleted: true,
			reportsLastSortByRole: null, //maybe fix this?
			reportsLastBreakUpByRole: false,
			reportsLastGroupByLocation: null, //maybe fix this?
			reportsLastOrderLocationByName: null, //maybe fix this?
			reportsOnlyLateConstraints: null,
			reportsFilterRoles: null,
			reportsFilterPlans: null,
			reportsFilterLocations: null,
			autoOpenProjectOverview: false,
			planDisableAliasing: false,
			ticketWorkDaysTestGroup: false,
			personalPlanning: false,
			featureWalkthroughR37: false,
		};

		let setters = {};

		for (let key in defaults) {
			(function (key) {
				let setterString = 'set' + key.charAt(0).toUpperCase() + key.slice(1);
				// By the time this is called, the 'key' is set to the last key in the defaults object.
				// Don't want to risk breaking more stuff, soooo huzzah for another argument :D...:(...:'(
				setters[setterString] = function (val, newKey) {
					key = newKey || key;
					if (val === undefined) {
						val = this[key];
					}
					this[key] = val;
					this.$save();
				};
			})(key);
		}

		function PreferenceFactory(ref) {
			$firebaseObject.call(this, ref);
			let self = this;
			this.userId = userId;
			this.$loaded().then(function () {
				self.loadDefaults();
			});
		}

		PreferenceFactory.prototype.loadDefaults = function () {
			let count = 0;
			for (let key in defaults) {
				if (this[key] === undefined || this[key] === null) {
					count++;
					this[key] = defaults[key];
				}
			}
			if (count) {
				return this.$save();
			} else {
				return this;
			}
		};
		PreferenceFactory.prototype.set = function (key, val) {
			if (val === undefined) {
				val = null;
			}
			this[key] = val;
			this.$save();
		};
		PreferenceFactory.prototype.setObj = function (obj) {
			for (let key in obj) {
				let val = obj[key];
				if (val === undefined) {
					val = null;
				}
				this[key] = val;
			}
			this.$save();
		};

		angular.extend(PreferenceFactory.prototype, setters);

		//can add methods later if desired, at the moment just use the object

		return function (id) {
			if (!id) {
				Logging.warning('preferences not loaded');
				return false;
			}
			userId = id;
			let fact = $firebaseObject.$extend(PreferenceFactory);
			const userPreferencesPath = fancyFirebaseGetters.getUserPreferencesPath(userId);
			let obj = new fact(
				fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(userPreferencesPath)
			);
			return obj;
		};
	},
]);
